import { createSelector } from 'reselect';

const selectProducts = (state: any) => state.products;


export const selectProductCurrentItem = createSelector([selectProducts], (products) => products.current);

export const selectProductListItems = createSelector([selectProducts], (products) => products.list);

export const selectProductItemById = (itemId: any) =>
    createSelector(selectProductListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectProductQueryItems = createSelector([selectProducts], (products) => products.query);

export const selectProductCreatedItem = createSelector([selectProducts], (products) => products.create);

export const selectProductUpdatedItem = createSelector([selectProducts], (products) => products.update);

export const selectProductReadItem = createSelector([selectProducts], (products) => products.read);

export const selectProductDeletedItem = createSelector([selectProducts], (products) => products.delete);

export const selectProductSearchedItems = createSelector([selectProducts], (products) => products.search);

export const selectProductItemsCount = createSelector([selectProducts], (products) => products.count);

export const selectProductItemsFilter = createSelector([selectProducts], (products) => products.filter);

export const selectProductSummaryItems = createSelector([selectProducts], (products) => products.summary);